var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['my-switch',{'is-checked':_vm.$attrs.value}],attrs:{"role":"switch","aria-checked":"true"},on:{"click":function($event){return _vm.$emit('input',!_vm.$attrs.value)}}},[_c('span',{staticClass:"my-switch__core"})])}
var staticRenderFns = []

export { render, staticRenderFns }